import { buildModelManager } from "../builder.js";
const DefaultAgentChatSelection = {
  __typename: true,
  id: true,
  agentType: true,
  completedAt: true,
  conversationConfig: true,
  conversationId: true,
  conversationSummary: { markdown: true, truncatedHTML: true },
  createdAt: true,
  instructions: { markdown: true, truncatedHTML: true },
  isActive: true,
  lastActivity: true,
  lastOpenAIResponseId: true,
  lastResponseId: true,
  localSessionId: true,
  messageCount: true,
  modelUsed: true,
  rollingWindow: true,
  sessionMetadata: true,
  status: true,
  summary: { markdown: true, truncatedHTML: true },
  title: true,
  tokenTotals: true,
  tools: true,
  totalTokens: true,
  updatedAt: true,
  userId: true,
  vectorStoreId: true
};
const modelApiIdentifier = "agentChat";
const pluralModelApiIdentifier = "agentChats";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAgentChatSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAgentChatSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAgentChatSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAgentChatSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAgentChatSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAgentChatSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAgentChatSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByConversationId",
    findByField: "conversationId",
    findByVariableName: "conversationId",
    modelApiIdentifier,
    defaultSelection: DefaultAgentChatSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByConversationId",
    findByField: "conversationId",
    findByVariableName: "conversationId",
    modelApiIdentifier,
    defaultSelection: DefaultAgentChatSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createAgentChat",
    operationReturnType: "CreateAgentChat",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { agentChat: { required: false, type: "CreateAgentChatInput" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAgentChatSelection
  },
  {
    type: "action",
    operationName: "bulkCreateAgentChats",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateAgentChatsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAgentChatSelection
  },
  {
    type: "action",
    operationName: "updateAgentChat",
    operationReturnType: "UpdateAgentChat",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      agentChat: { required: false, type: "UpdateAgentChatInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAgentChatSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateAgentChats",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateAgentChatsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAgentChatSelection
  },
  {
    type: "action",
    operationName: "deleteAgentChat",
    operationReturnType: "DeleteAgentChat",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteAgentChats",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertAgentChat",
    operationReturnType: "UpsertAgentChat",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      agentChat: { required: false, type: "UpsertAgentChatInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateAgentChatResult": { hasReturnType: false },
      "... on UpdateAgentChatResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAgentChatSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertAgentChats",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertAgentChatsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultAgentChatSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "agentChatGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const AgentChatManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultAgentChatSelection,
  operations
);
export {
  AgentChatManager,
  DefaultAgentChatSelection
};
//# sourceMappingURL=AgentChat.js.map
